import { render, staticRenderFns } from "./AboutAQ.vue?vue&type=template&id=683b0753&"
import script from "./AboutAQ.vue?vue&type=script&lang=js&"
export * from "./AboutAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports